function AuthFailed() {
  return <div>AuthFailed</div>;
}

export default AuthFailed;
